// 网格
import rlEntity from "./rlEntity";

import { create2dAnyLine, create3dAnyLine } from "../threeObject/index";

// import mxcad from "mxcad";
import mxcad from "mxcad";

import { arrayTypeAnnotation } from "@babel/types";
const { McDbPoint, McDbLine, McGePoint3d, McCmColor } = mxcad;
import { resetRlModules } from "@/mixins/LiteModuleDb.js";
import store from "@/store/index";

class rlLineGrid extends rlEntity {
  constructor() {
    super();

    this.points = []; // 顶点列表
    this.m_stJoint = null; // 起点节点
    this.m_edJoint = null; // 终点节点
    this.m_Axis = null; //关联的轴线
    this.mcDbGrid = new McDbLine(); //关联的cad直线类
    this.mcDbGridId = null; //关联的cad直线类图形id

    this.classTypeName = "rlGrid"; // 网格
    this._threeObj = null; //三维图形对象

    this.m_wallId = null; //网格上的墙
    this.m_beamId = null; //网格上的梁
    this.m_slabIds = []; //网格上的板集合
    this.m_wallHoleId = null; //网格上的墙洞
    this.m_ringBeamId = null; //网格上的圈梁

    // this.defaultColor = '#ff0000' //默认颜色
    this.Color = "#FF0000"; //构件颜色

    this.m_groupName = "rlLineGridGroup"; //组名
  }

  // 自定义对象在绘制时会重新创建
  create() {
    return new this.constructor();
  }

  // 克隆
  myClone() {
    let newObj = this.clone();
    newObj.m_stJoint = this.m_stJoint.myClone();
    newObj.m_edJoint = this.m_edJoint.myClone();
    newObj.m_Axis = null;
    newObj.m_stdFlrGuid = this.m_stdFlrGuid;
    return newObj;
  }

  initData(obj) {
    super.initData(obj);
    this.m_stJoint = obj.m_stJoint;
    this.m_edJoint = obj.m_edJoint;
    this.m_Axis = obj.m_Axis;
    // this.ID = obj.ID
    this.points = [
      new THREE.Vector3(...this.m_stJoint.m_pt),
      new THREE.Vector3(...this.m_edJoint.m_pt),
    ];
  }

  //用于撤销回退
  reDraw(obj) {
    super.reDraw(obj);
    this.m_stJoint = rlAppObj.rlMxDrawObject.getMxEntity(obj.m_stJoint);
    this.m_edJoint = rlAppObj.rlMxDrawObject.getMxEntity(obj.m_edJoint);
    this.m_Axis = rlAppObj.rlMxDrawObject.getMxEntity(obj.m_Axis);

    this.points = [
      new THREE.Vector3(...this.m_stJoint.m_pt),
      new THREE.Vector3(...this.m_edJoint.m_pt),
    ];

    this.m_wallId = obj.m_wallId; //网格上的墙
    this.m_beamId = obj.m_beamId; //网格上的梁
    this.m_slabIds = obj.m_slabIds; //网格上的板集合
    this.m_wallHoleId = obj.m_wallHoleId; //网格上的墙洞
    this.m_ringBeamId = obj.m_ringBeamId; //网格上的圈梁
  }

  // 添加
  add(obj) {
    this.m_stJoint = obj.m_stJoint;
    this.m_edJoint = obj.m_edJoint;
    this.m_stdFlrGuid = obj.m_stdFlrGuid;
    this.m_Axis = obj.m_Axis;
    this.Guid = obj.Guid ? obj.Guid : this.Guid;
    // this.ID = obj.ID
    this.points = [
      new THREE.Vector3(...this.m_stJoint.m_pt),
      new THREE.Vector3(...this.m_edJoint.m_pt),
    ];
  }

  // 生成网格
  setPoints(points) {
    // setStartPt(points[0]);
    // setEndPt(points[1]);
    this.points = [
      new THREE.Vector3(...points[0]),
      new THREE.Vector3(...points[1]),
    ];
  }

  // 绘制
  worldDraw(pWorldDraw) {
    if (pWorldDraw.mxObj._is2d) {
      this.mcDbGrid.startPoint = new McGePoint3d(
        this.points[0]["x"],
        this.points[0]["y"],
        this.points[0]["z"]
      );
      this.mcDbGrid.endPoint = new McGePoint3d(
        this.points[1]["x"],
        this.points[1]["y"],
        this.points[1]["z"]
      );
      this.mcDbGrid.trueColor = new McCmColor(0, 0, 0);
      this.m_stJoint &&
        this.m_stJoint.mcDbPoint.setPosition(
          this.points[0]["x"],
          this.points[0]["y"],
          this.points[0]["z"]
        );
      this.m_edJoint &&
        this.m_edJoint.mcDbPoint.setPosition(
          this.points[1]["x"],
          this.points[1]["y"],
          this.points[1]["z"]
        );

      // wLineObj = create2dAnyLine(this.points);
      // wLineObj.material.color.set("#ff0000");
      pWorldDraw.setColor(new THREE.Color(this.Color));
      pWorldDraw.drawLine(this.points[0], this.points[1]);
    }
    this._threeObj = create3dAnyLine(this.points);

    this.mcDbGrid.setxDataString("mcObjectId", this.objectId().toString());

    this.mcDbGrid.setxDataString("ceshi", {
      name: "啧啧啧",
      age: "18",
      pige: { name: "小鸽子" },
      list: [1, 2, 3],
    });

    if (this.m_stJoint) {
      if (!this.m_stJoint.m_gridIds.includes(this.objectId())) {
        this.m_stJoint.m_gridIds.push(this.objectId());
        //
      }
    }

    if (this.m_edJoint) {
      if (!this.m_edJoint.m_gridIds.includes(this.objectId())) {
        this.m_edJoint.m_gridIds.push(this.objectId());
        //
      }
    }

    if (this.m_Axis) {
      if (!this.m_Axis.m_gridIds.includes(this.objectId())) {
        this.m_Axis.m_gridIds.push(this.objectId());
      }
    }
    // pWorldDraw.drawEntity(wLineObj);
  }

  //数据修改更新
  async updateThisObj(obj) {
    this.initData(obj);
    //删除功能选择多个同时删除时需要及时处理关联关系
    if (this.m_stJoint) {
      if (!this.m_stJoint.m_gridIds.includes(this.objectId())) {
        this.m_stJoint.m_gridIds.push(this.objectId());
      }
    }

    if (this.m_edJoint) {
      if (!this.m_edJoint.m_gridIds.includes(this.objectId())) {
        this.m_edJoint.m_gridIds.push(this.objectId());
      }
    }
    this.setNeedUpdateDisplay();

    await resetRlModules(
      this.classTypeName,
      store.state.globalData.rl_stdFlr_id,
      this.Guid,
      this.getDataBase()
    );
  }

  erase() {
    //删除网格上的梁
    if (this.m_beamId) {
      let objtmp = rlAppObj.rlMxDrawObject.getMxEntity(this.m_beamId);
      if (objtmp) objtmp.erase();
    }

    //删除网格上的墙
    if (this.m_wallId) {
      let objtmp = rlAppObj.rlMxDrawObject.getMxEntity(this.m_wallId);
      if (objtmp) objtmp.erase();
    }

    //删除网格上的板
    if (this.m_slabIds) {
      this.m_slabIds.forEach((itemID) => {
        let objtmp = rlAppObj.rlMxDrawObject.getMxEntity(itemID);
        if (objtmp) objtmp.erase();
      });
    }

    //该网格下的轴线删除与该网格的关联关系
    if (this.m_Axis) {
      this.m_Axis.m_gridIds = this.m_Axis.m_gridIds.filter(
        (item) => item != this.objectId()
      );

      // 删除没有关联的轴线
      if (
        !this.m_Axis.m_gridIds ||
        (this.m_Axis.m_gridIds && this.m_Axis.m_gridIds.length < 1)
      ) {
        this.m_Axis.erase();
      }
    }

    //删除与节点之间的关联
    if (this.m_stJoint) {
      this.m_stJoint.m_gridIds = this.m_stJoint.m_gridIds.filter(
        (item) => item != this.objectId()
      );
    }

    if (this.m_edJoint) {
      this.m_edJoint.m_gridIds = this.m_edJoint.m_gridIds.filter(
        (item) => item != this.objectId()
      );
    }

    //同步删除indexdb
    //to do...
    super.erase();
  }

  // 返回图形源数据
  getDataBase() {
    let data = super.getDataBase();
    if (this.m_stJoint) data["Jt1Guid"] = this.m_stJoint.Guid;

    if (this.m_edJoint) data["Jt2Guid"] = this.m_edJoint.Guid;

    if (this.m_Axis) data["AxisGuid"] = this.m_Axis.Guid;

    return data;
  }

  getDrawData() {
    let data = super.getDrawData();

    // data["Color"] = new THREE.Color(0xff0000);
    data["m_stJoint"] = this.m_stJoint.objectId();
    data["m_edJoint"] = this.m_edJoint.objectId();
    data["m_Axis"] = this.m_Axis.objectId();
    data["m_wallId"] = this.m_wallId;
    data["m_beamId"] = this.m_beamId;
    data["m_slabIds"] = this.m_slabIds;
    data["m_wallHoleId"] = this.m_wallHoleId;
    data["m_ringBeamId"] = this.m_ringBeamId;
    return data;
  }
  // 输出同理
  dwgOut(obj) {
    this.onDwgOut(obj);
    obj["points"] = [];
    this.points.forEach((val) => {
      obj["points"].push(val.clone());
    });
    // if (this.ID) {
    //   this.statusType = 2
    // }
    return obj;
  }

  // 数据读入
  dwgIn(obj) {
    // // 这里是公共的属性
    this.onDwgIn(obj);
    //  // 这里是自定义对象自己的属性
    let ary = obj["points"];
    this.points = [];
    ary.forEach((val) => {
      this.points.push(val.clone());
    });
    return true;
  }

  // 偏移
  transformBy(_mat) {
    this.points[0].add(_mat);
    this.points[1].add(_mat);

    if (this.mcDbGridId) {
      let objTm = this.mcDbGridId.getMcDbEntity();
      objTm.startPoint = new McGePoint3d(
        this.points[0]["x"],
        this.points[0]["y"],
        this.points[0]["z"]
      );
      objTm.endPoint = new McGePoint3d(
        this.points[1]["x"],
        this.points[1]["y"],
        this.points[1]["z"]
      );
    }

    if (this.m_beamId) {
      let objtmp = rlAppObj.rlMxDrawObject.getMxEntity(this.m_beamId);

      if (objtmp) {
        objtmp.saveEditRevokeData(); //修改数据前保存数据
        objtmp.transformBy(_mat);
        objtmp.updateThisObj(objtmp);
      }
    }
    if (this.m_wallId) {
      let objtmp = rlAppObj.rlMxDrawObject.getMxEntity(this.m_wallId);

      if (objtmp) {
        objtmp.saveEditRevokeData(); //修改数据前保存数据
        objtmp.transformBy(_mat);
        objtmp.updateThisObj(objtmp);
      }
    }
    if (this.m_ringBeamId) {
      let objtmp = rlAppObj.rlMxDrawObject.getMxEntity(this.m_ringBeamId);

      if (objtmp) {
        objtmp.saveEditRevokeData(); //修改数据前保存数据
        objtmp.transformBy(_mat);
        objtmp.updateThisObj(objtmp);
      }
    }
    if (this.m_wallHoleId) {
      let objtmp = rlAppObj.rlMxDrawObject.getMxEntity(this.m_wallHoleId);

      if (objtmp) {
        objtmp.saveEditRevokeData(); //修改数据前保存数据
        objtmp.transformBy(_mat);
        objtmp.updateThisObj(objtmp);
      }
    }

    this.setNeedUpdateDisplay(true);
  }
}

export { rlLineGrid };
